import React from 'react'
import styled from 'styled-components'
import { breakpoints } from './../../constants'
import { BLUE, PRIMARY_COLOR, LIGHTGRAY } from '../../styles/colors.style'

const StyledDiv = styled.div`
	display: inline-block;
	line-height: 0px;
	margin-right: 16px;
	vertical-align: middle;

	svg {
		fill: ${({ isActive }) => (isActive ? LIGHTGRAY : '#fff')};
		height: 22px;
		width: 22px;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			fill: ${({ isActive }) => (isActive ? PRIMARY_COLOR : BLUE)};
		}
	}
`

const MenuIcon = ({ isActive, Icon, title }) =>
	Icon ? (
		<StyledDiv isActive={isActive}>
			<Icon title={title} />
		</StyledDiv>
	) : null

export default MenuIcon
